// import logo from './logo.svg';
import './App.css';
import React from "react";
import {Navbar} from "./components/navbar";
import { Introduction } from './components/introduction';
import { About } from './components/about';
import { Technical } from './components/technical';
import { Projects } from './components/Projects';
import { Contact } from './components/contact';
import { ContactForm } from './components/contactForm';
import { Alert } from './components/alert';
import { Whatsapp } from './components/whatsapp';
import { SuccessEmail } from './components/successEmail';
import { AlertContext } from "./context/alertContext";

// import { Body } from './newComponents/body/body';
// import {Navbar} from "./newComponents/navbar/navbar";

function App() {
  const {contact, about, skills, project} = React.useContext(AlertContext);

  return (
    <div>
      <Navbar />
      <Introduction/>
      <div ref={about} className="margin-top"></div>
      <About />
      <div ref={skills} className="margin-top"></div>
      <Technical />
      <div ref={project} className="margin-small"></div>
      <Projects/>
      <div ref={contact} className="margin-top"></div>
      <ContactForm />
      <Contact/>
      {/* <Body/>
      <Navbar/> */}
      <Alert />
      <Whatsapp/>
      <SuccessEmail />
    </div>
  );
}

export default App;